export default __webpack_public_path__ + "static/media/logo-spread-white.e84001e3.svg";